import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppRouting } from './app-routing.module';

bootstrapApplication(AppComponent, {
  providers: [AppRouting]
});
